var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"fds-egb-alert-trigger-toggle"},[_c('fds-alert-trigger-toggle',{attrs:{"locale":_vm.locale,"id":_vm.idNotation,"has-icon-title":_vm.hasIconTitle},on:{"on-control-click":_vm.onControlClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }